import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add_to",
  "use": "icon-add_to-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-add_to\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n<path d=\"M12,5a7,7,0,1,0,7,7A7,7,0,0,0,12,5Zm3,8H13v2H11V13H9V11h2V9h2v2h2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol